import { createI18n } from 'vue-i18n'
import type { SupportedLocale } from '@architeia/types'
import en from './locales/en.json'
import de from './locales/de.json'

/** ADR-010 D3: the languages this product ships. A subset of the account languages is allowed. */
export const SECRET_ORG_LOCALES = ['en', 'de'] as const satisfies readonly SupportedLocale[]
export type SecretOrgLocale = (typeof SECRET_ORG_LOCALES)[number]
export const SECRET_ORG_FALLBACK_LOCALE: SecretOrgLocale = 'en'

export const i18n = createI18n({
  legacy: false,
  locale: SECRET_ORG_FALLBACK_LOCALE,
  fallbackLocale: SECRET_ORG_FALLBACK_LOCALE,
  // `useLocaleSync` corrects the initial locale from the effective-locale derivation during App
  // setup. A shipped locale can never lack a bundle (the `satisfies` below).
  messages: { en, de } satisfies Record<SecretOrgLocale, typeof en>
})
